import { render, staticRenderFns } from "./moduleTemplateItem.vue?vue&type=template&id=446ebc45&functional=true&"
import script from "./moduleTemplateItem.vue?vue&type=script&lang=ts&"
export * from "./moduleTemplateItem.vue?vue&type=script&lang=ts&"
import style0 from "./moduleTemplateItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports